import { Alert, Button, ButtonBorder, Div, Label } from "components";
import { EStyle, Ecolors } from "constants/themes";
import React, { useRef, useState } from "react";
import { ScrollView, StyleSheet } from "react-native";
import { apiInvestment } from "services/apiInvestment";
import { useNavigationLog } from "services/navigation";
import { useAppSelector } from "store/hooks";
import { heightScale, widthScreen } from "utils";
import { convertNumber, convertTimestamp, copyToClipboard } from "utils/utils";

interface Props {
  product: any;
  scheme: any;
  amount: any;
  currentSession: any;
  excuseTempVolumn: any;
  bankSuperVisory: any;
  rmCode?: string;
  stepTimeLine?: number;
  setOrderData?: (t: any) => void;
  onNext?: () => void;
  onPre?: () => void;
}

function RowSpaceItem(p: {
  marginTop?: number;
  paddingHorizontal?: number;
  children?: any;
  isBorderBottom?: boolean;
}) {
  return (
    <>
      <Div
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        marginTop={p.marginTop ?? 0}
        paddingHorizontal={p.paddingHorizontal ?? 0}
      >
        {p.children && p.children}
      </Div>
      {p.isBorderBottom && (
        <Div
          marginTop={15}
          width={"100%"}
          height={1}
          backgroundColor={Ecolors.spaceColor}
        />
      )}
    </>
  );
}

function ContentCoppy(p: {
  title: string;
  content: string;
  isBorderBottom?: boolean;
  marginTop?: number;
  isBtn?: boolean;
}) {
  return (
    <RowSpaceItem marginTop={p.marginTop} isBorderBottom={p.isBorderBottom}>
      <Div flex={1}>
        <Label color={Ecolors.grayColor} size={14}>
          {p.title}
        </Label>
        <Label marginTop={5} multilanguage={false} size={14}>
          {p.content}
        </Label>
      </Div>
      {p.isBtn ? (
        <Button
          onPress={() => {
            copyToClipboard(p.content);
          }}
          width={61}
          height={26}
          alignItems={"center"}
          justifyContent={"center"}
          borderRadius={5}
          backgroundColor={Ecolors.yellowColor}
        >
          <Label size={14} multilanguage={false}>
            COPY
          </Label>
        </Button>
      ) : (
        <Div width={61} height={26} />
      )}
    </RowSpaceItem>
  );
}

function OrderBuyStep2({
  product,
  scheme,
  amount,
  currentSession,
  excuseTempVolumn,
  stepTimeLine,
  setOrderData,
  onNext,
  rmCode,
  onPre,
}: Props) {
  const I18nState = useAppSelector((state) => state.languages.I18nState);
  const navigate = useNavigationLog();
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const onConfirm = async () => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    try {
      setLoading(true);
      const orderData = {
        amount: amount.replace(/[,]/g, "") || 0,
        // #MIO-59 MIO \ Webview \ Mua SIP \ Ẩn field ngày bắt đầu - mặc định là ngày 1
        beginBuyAutoStartDate: 1,
        closedBankNoteTime: currentSession?.closedBankNoteTime || 0,
        closedOrderBookTime: currentSession?.closedOrderBookTime || 0,
        closedBankNoteTimeString:
          currentSession?.closedBankNoteTimeString || "0",
        closedOrderBookTimeString:
          currentSession?.closedOrderBookTimeString || "0",
        createdDate: new Date().getTime(),
        investmentNumber: excuseTempVolumn?.investmentNumber || "0",
        isBuyAuto: scheme?.productSchemeIsAutoBuy ? 1 : 0 || 0,
        productId: product?.id || 0,
        productName: product?.name || "",
        productProgramId: scheme?.id || 0,
        productSchemeCode: scheme?.productSchemeCode || "",
        productSchemeIsAutoBuy: scheme?.productSchemeIsAutoBuy || false,
        productSchemeNameEn: scheme?.productSchemeNameEn || "",
        tradeCode: scheme?.tradeCode || "",
        tradingTime: currentSession?.tradingTime || 0,
        tradingTimeString: currentSession?.tradingTimeString || "",
      };
      const res = await apiInvestment.createBuyOrder(orderData);
      if (res.status == 200) {
        const updateRmCodeResponse = await apiInvestment.updateRmCode({
          orderCode: res.data.orderCode,
          rmCode: rmCode || "",
        });

        setOrderData &&
          setOrderData({
            orderData: {
              ...orderData,
              productCode: product.code,
              rmCode: rmCode || "",
            },
            data: res.data,
          });
        if (res.data.otpInfo) {
          navigate("OtpRequestModal", {
            data: {
              requestOnSendOtp: res.data.otpInfo,
              flowApp: "CreateOrderBuy",
              onConfirm: () => {
                onNext && onNext();
              },
            },
          });
          return;
        }
        onNext && onNext();
        return;
      }
      Alert.showError({
        content: I18nState == "vi" ? res.message : res.messageEn,
        multilanguage: false,
      });
      return;
    } catch (error: any) {
      Alert.showError({
        content: I18nState == "vi" ? error.message : error.messageEn,
        multilanguage: false,
      });
      return;
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  if (stepTimeLine != 2) {
    return <Div screen={true} />;
  }
  return (
    <Div screen={true}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <Div paddingHorizontal={16}>
          <Label
            fontWeight={"700"}
            marginTop={18}
          >{`createordermodal.phuongphapthanhtoan`}</Label>
          <Div
            flexDirection={"row"}
            marginTop={5}
            flexWrap={"wrap"}
            alignItems={"center"}
            justifyContent={"flex-start"}
          >
            <Label multilanguage={false}>
              <Label
                size={14}
              >{`createordermodal.thoidiemdongsolenhnhantien`}</Label>
              <Label
                size={14}
                color={Ecolors.linkColor}
                multilanguage={false}
                marginLeft={3}
              >
                {` ${currentSession?.closedBankNoteTimeString}`}
                {I18nState == "vi" ? " (Giờ VN)" : " (VNT)"}
              </Label>
            </Label>
          </Div>

          <Label
            marginTop={20}
            fontWeight={"700"}
          >{`createordermodal.thongtindautu`}</Label>
          <Div
            width={"100%"}
            marginTop={9}
            borderRadius={8}
            borderWidth={0.8}
            borderColor={Ecolors.bordercolor}
            backgroundColor={Ecolors.whiteColor}
            style={EStyle.shadowItem}
            paddingHorizontal={20}
            paddingTop={20}
            paddingBottom={24}
          >
            <RowSpaceItem>
              <Label size={14}>{`createordermodal.sotienmua`}</Label>

              <Label multilanguage={false} size={14}>
                {convertNumber(amount)}
              </Label>
            </RowSpaceItem>
            <Div borderBottomColor={Ecolors.spaceColor} borderBottomWidth={1}>
              <Label
                multilanguage={false}
                size={14}
                marginTop={8}
                marginLeft={30}
                marginBottom={15}
                style={{
                  fontStyle: "italic",
                  textAlign: "right",
                }}
              >
                {/*  {I18nState == 'vi' ? doc(amount.replace(/[,]/g, '')).charAt(1).toUpperCase() +
                doc(amount.replace(/[,]/g, '')).slice(2) + ' đồng' :
                converter.toWords(Number(amount.replace(/[,]/g, ''))) + ' dong'

              } */}
                {I18nState == "vi"
                  ? excuseTempVolumn?.amountText
                  : excuseTempVolumn?.amountTextEn}
              </Label>
            </Div>

            <RowSpaceItem marginTop={15} isBorderBottom={true}>
              <Label size={14}>{`createordermodal.quydautu`}</Label>
              <Div
                flex={1}
                flexDirection={"row"}
                alignItems={"center"}
                paddingLeft={10}
                justifyContent={"flex-end"}
              >
                <Label size={14} multilanguage={false}>
                  {I18nState == "vi" ? product?.name : product?.nameEn || ""}
                </Label>
              </Div>
            </RowSpaceItem>
            <RowSpaceItem marginTop={15} isBorderBottom={true}>
              <Label size={14}>{`createordermodal.chuongtrinh`}</Label>
              <Div
                flex={1}
                flexDirection={"row"}
                paddingLeft={10}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <Label multilanguage={false} size={14}>
                  {I18nState == "vi" ? scheme?.name : scheme?.nameEn}
                </Label>
              </Div>
            </RowSpaceItem>
            <RowSpaceItem marginTop={15} isBorderBottom={true}>
              <Label size={14}>{`createordermodal.loailenh`}</Label>
              <Label size={14}>{`createordermodal.mua`}</Label>
            </RowSpaceItem>
            <RowSpaceItem marginTop={15} isBorderBottom={true}>
              <Label size={14}>{`createordermodal.ngaydatlenh`}</Label>
              <Label multilanguage={false} size={14}>
                {convertTimestamp(new Date().getTime(), "DD/MM/yyyy, HH:mm")}
                {I18nState == "vi" ? " (Giờ VN)" : " (VNT)"}
              </Label>
            </RowSpaceItem>
            <RowSpaceItem marginTop={15}>
              <Label size={14}>{`createordermodal.phiengiaodich`}</Label>
              <Label multilanguage={false} size={14}>
                {currentSession?.tradingTimeString}
                {I18nState == "vi" ? " (Giờ VN)" : " (VNT)"}
              </Label>
            </RowSpaceItem>
          </Div>
        </Div>

        <Div height={100} />
      </ScrollView>
      <RowSpaceItem paddingHorizontal={29} marginTop={10}>
        <ButtonBorder
          width={148}
          height={48}
          type={2}
          onPress={() => {
            // goBack();
            onPre && onPre();
          }}
          title={`createordermodal.quaylai`}
        />
        <ButtonBorder
          width={148}
          loading={loading}
          onPress={onConfirm}
          height={48}
          title={`createordermodal.xacnhan`}
        />
      </RowSpaceItem>

      <Div height={190} />
    </Div>
  );
}
const s = StyleSheet.create({
  scrollviewHeader: {
    width: widthScreen,
    height: heightScale(50),
    flexDirection: "row",
  },
});
export default React.memo(OrderBuyStep2);
